import { useEffect } from 'react';
import { appHistory } from 'routes/appHistory';

const MESSAGE_SOURCE = 'tmc-grafana-link';

// Sólo aceptamos rutas internas: empiezan por "/" pero no por "//" (protocol-relative),
// para que un mensaje manipulado no pueda sacar al usuario fuera de la aplicación.
const isInternalPath = (to: unknown): to is string => typeof to === 'string' && /^\/(?!\/)/.test(to);

/**
 * Escucha los mensajes que emite `public/grafana-link.html` cuando el usuario pincha
 * un data link dentro del Grafana embebido, y navega la SPA a la ruta indicada.
 *
 * En Grafana el link debe apuntar a
 *   https://<front>/grafana-link.html?to=/user/${__data.fields.userId}
 * con "Open in new tab" DESACTIVADO (tiene que navegar dentro del iframe).
 */
export const useGrafanaLinkBridge = () => {
  useEffect(() => {
    const onMessage = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return;
      if (event.data?.source !== MESSAGE_SOURCE) return;
      if (!isInternalPath(event.data.to)) return;

      appHistory.push(event.data.to);
    };

    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, []);
};
